const UserGroup = {
  LocqAdmin: "locq_admin",
  Seaoil: "seaoil",
  SeaoilRetailPricing: "seaoil_retail_pricing",
};

export default UserGroup;
